export const EXPERT_FEATURES = [
  {
    iconSrc:
      'https://assets.clear.in/cleartax/images/1746771196_videoconference.svg',
    heading: 'Live Tax filing experience',
  },
  {
    iconSrc:
      'https://assets.clear.in/cleartax/images/1746770426_clockcounterclockwise.svg',
    heading: 'Guaranteed filing in 24 hours',
  },
  {
    iconSrc: 'https://assets.clear.in/cleartax/images/1746771162_users.svg',
    heading: "Hand-pick from India's Top Tax experts",
  },
  {
    iconSrc: 'https://assets.clear.in/cleartax/images/1746771058_chartbar.svg',
    heading: 'Tax done with 100% accuracy',
  },
];

export const ITR_SECTION_HEADING = 'Expert assisted ITR filing plans';
export const BUSINESS_SECTION_HEADING = 'Expert assisted Business plans';

export const EXPERT_ASSISTED_PLANS_ID = 'expert_assisted_plans';

export const LUXURY_TAX_UTM_REF = 'plan_card_partner_page_luxury';
export const LUXURY_TAX_HEADING = 'Luxury Tax Support, All Year Round';
export const LUXURY_TAX_FEATURES = [
  'All-inclusive personal tax expert at your service',
  '24*7 / 365 days, calls & live sessions',
  'All Complex Tax Compliances ',
  'Tailored for high income earners & business owners',
  'Includes benefit of all other plans ',
];

export const EXPERT_SESSION_HEADING = 'Expert Tax Help, One Call Away';
export const EXPERT_SESSION_FEATURES = [
  'Advisory for salaried individuals,freelancers,financial traders',
  '45 minutes call session with a ClearTax expert',
  'Get answers to your tax related queries',
  'Get a dedicated relationship manager during service fulfillment.',
];

export const PLAN_CAROUSEL_CLASS =
  'custom-overflow custom-overflow-bg-white cards-custom-margin mt-12';

export const LUXURY_PLAN_IDS = ['prod_itr_af_luxury'];
export const EXPERT_SESSION_PLAN_IDS = ['prod_ask_expert_plan'];
